import { render, staticRenderFns } from "./NotificationsToggle.vue?vue&type=template&id=6f7a215f&"
import script from "./NotificationsToggle.vue?vue&type=script&lang=js&"
export * from "./NotificationsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports